import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { BuildingType } from 'commons/src/models/commonTypeScript';
import { PDFContext } from '../../../../../models/common';
import iaqInsight2PdfStyles from '../utils/pdfStyles';

type IaqInsight2HeaderProps = {
    building: BuildingType;
    translationFunction: PDFContext;
    fromDate: string | null;
    toDate: string | null;
};

const IaqInsight2Header = ({
    building,
    translationFunction,
    fromDate,
    toDate,
}: IaqInsight2HeaderProps): React.ReactElement => {
    const introParagraph =
        fromDate && toDate
            ? translationFunction('IAQReport2.ReportGeneratedPeriod', { from: fromDate, to: toDate })
            : translationFunction('IAQReport2.MeasurementResultExplained');

    return (
        <View>
            <Text style={iaqInsight2PdfStyles.reportTitle}>{translationFunction('IAQReport2.IAQReport')}</Text>
            <Text style={iaqInsight2PdfStyles.introParagraph}>{introParagraph}</Text>
            <Text style={iaqInsight2PdfStyles.buildingName}>{building.name}</Text>
            <Text style={iaqInsight2PdfStyles.buildingAddress}>{building.address || ''}</Text>
        </View>
    );
};

export default IaqInsight2Header;
